/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleLandingPageCommercialContextData
 */
export interface GoogleLandingPageCommercialContextData {
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageCommercialContextData
     */
    host?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageCommercialContextData
     */
    erpOrders?: string;
    /**
     * Legacy all-status order header amount including VAT in project-currency minor units.
     * @type {string}
     * @memberof GoogleLandingPageCommercialContextData
     */
    erpTurnover?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageCommercialContextData
     */
    completedOrders?: string | null;
    /**
     * Canonical net goods revenue in project-currency minor units for completed sales.
     * @type {string}
     * @memberof GoogleLandingPageCommercialContextData
     */
    completedGoodsRevenue?: string | null;
    /**
     * Null: source publication coverage is not known.
     * @type {boolean}
     * @memberof GoogleLandingPageCommercialContextData
     */
    coverageComplete?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageCommercialContextData
     */
    commerceScope?: string;
}

/**
 * Check if a given object implements the GoogleLandingPageCommercialContextData interface.
 */
export function instanceOfGoogleLandingPageCommercialContextData(value: object): value is GoogleLandingPageCommercialContextData {
    return true;
}

export function GoogleLandingPageCommercialContextDataFromJSON(json: any): GoogleLandingPageCommercialContextData {
    return GoogleLandingPageCommercialContextDataFromJSONTyped(json, false);
}

export function GoogleLandingPageCommercialContextDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleLandingPageCommercialContextData {
    if (json == null) {
        return json;
    }
    return {
        
        'host': json['host'] == null ? undefined : json['host'],
        'erpOrders': json['erpOrders'] == null ? undefined : json['erpOrders'],
        'erpTurnover': json['erpTurnover'] == null ? undefined : json['erpTurnover'],
        'completedOrders': json['completedOrders'] === undefined ? undefined : json['completedOrders'] === null ? null : json['completedOrders'],
        'completedGoodsRevenue': json['completedGoodsRevenue'] === undefined ? undefined : json['completedGoodsRevenue'] === null ? null : json['completedGoodsRevenue'],
        'coverageComplete': json['coverageComplete'] === undefined ? undefined : json['coverageComplete'] === null ? null : json['coverageComplete'],
        'commerceScope': json['commerceScope'] == null ? undefined : json['commerceScope'],
    };
}

export function GoogleLandingPageCommercialContextDataToJSON(json: any): GoogleLandingPageCommercialContextData {
    return GoogleLandingPageCommercialContextDataToJSONTyped(json, false);
}

export function GoogleLandingPageCommercialContextDataToJSONTyped(value?: GoogleLandingPageCommercialContextData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'host': value['host'],
        'erpOrders': value['erpOrders'],
        'erpTurnover': value['erpTurnover'],
        'completedOrders': value['completedOrders'],
        'completedGoodsRevenue': value['completedGoodsRevenue'],
        'coverageComplete': value['coverageComplete'],
        'commerceScope': value['commerceScope'],
    };
}

